<!-- <input type="input" [formControl]="formControl" [formlyAttributes]="field"> -->
<div>
  <button title="{{hint}}" class="btn btn-outline-primary" (click)="openPickerModel()" [disabled]="field.templateOptions.disabled">
    {{buttonName}}
  </button>
    <span style="margin-left: 15px;"> <b>{{count}} {{countMessage}}/s added.</b></span>
</div>
